import { useAuthStore } from '@/common/stores/auth';
import { assetUrl } from '@/helpers/assetUrl';

export default {
  path: '/traffic-stats',
  name: 'traffic-stats-parent',
  component: () => import('@/modules/traffic-stats/pages/TrafficStats.vue'),
  meta: {
    metaTags: [
      {
        name: 'description',
        content: 'Shows you what keywords are bringing traffic to your Etsy shop and what keywords were used to click into your listing.',
      },
      {
        property: 'og:title',
        content: 'eRank - Traffic Stats',
      },
      {
        property: 'og:description',
        content: 'Shows you what keywords are bringing traffic to your Etsy shop and what keywords were used to click into your listing.',
      },
      {
        property: 'og:site_name',
        content: 'eRank LTD',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        name: 'twitter:title',
        content: 'eRank — Traffic Stats',
      },
      {
        name: 'twitter:description',
        content: 'Shows you what keywords are bringing traffic to your Etsy shop and what keywords were used to click into your listing.',
      },
      {
        name: 'twitter:card',
        content: 'summary',
      },
      {
        name: 'p:domain_verify',
        content: '4a452b9edfa7318bd9a45fe0d20a25c0',
      },
      {
        name: 'google-site-verification',
        content: '-2cfMO7MeRJeifFFxsIOq3Ifssa2ai61ngBq40DYYkM',
      },
      {
        name: 'msvalidate.01',
        content: '65CFA6CFB407B1A92CCA3F3FB7B1D174',
      },
      {
        name: 'msapplication-TileColor',
        content: '#da532c',
      },
      {
        name: 'msapplication-config',
        content: assetUrl('/favicons/browserconfig.xml'),
      },
      {
        name: 'theme-color',
        content: '#ffffff',
      },
      {
        name: 'apple-mobile-web-app-capable',
        content: 'yes',
      },
      {
        name: 'mobile-web-app-capable',
        content: 'yes',
      },
      {
        page_slug: 'traffic-stats',
      },
    ],
    requiresAuth: true,
    title: 'eRank — Traffic Stats',
  },
  children: [
    {
      path: '',
      name: 'Main',
      component: () => import('@/modules/traffic-stats/pages/Overview.vue'),
    },
    {
      path: 'etsy',
      name: 'Etsy',
      component: () => import('@/modules/traffic-stats/pages/Etsy.vue'),
    },
    {
      path: 'social',
      name: 'Social',
      component: () => import('@/modules/traffic-stats/pages/Social.vue'),
    },
    {
      path: 'other',
      name: 'Other',
      component: () => import('@/modules/traffic-stats/pages/Other.vue'),
    },
    {
      path: 'badges',
      name: 'Badges',
      component: () => import('@/modules/traffic-stats/pages/Badges.vue'),
    },
    {
      path: 'listing-hops',
      name: 'ListingHops',
      component: () => import('@/modules/traffic-stats/pages/ListingHops.vue'),
    },
    {
      path: 'listing/:id/organic-search',
      name: 'Organic-Search',
      component: () => {
        const authStore = useAuthStore();
      
        if (authStore.user.current_shop?.shop_name == null) {
          return import('@/modules/traffic-stats/pages/Etsy.vue');
        }

        return import('@/modules/traffic-stats/pages/Organic.vue');
      },
    },
    {
      path: 'listing/:id/etsy-ads',
      name: 'EtsyAds',
      component: () => {
        const authStore = useAuthStore();
      
        if (authStore.user.current_shop?.shop_name == null) {
          return import('@/modules/traffic-stats/pages/Etsy.vue');
        }

        return import('@/modules/traffic-stats/pages/EtsyAds.vue');
      },
    },
    {
      path: 'listing/:id/pinterest',
      name: 'Pinterest',
      component: () => {
        const authStore = useAuthStore();
      
        if (authStore.user.current_shop?.shop_name == null) {
          return import('@/modules/traffic-stats/pages/Etsy.vue');
        }

        return import('@/modules/traffic-stats/pages/Pinterest.vue');
      },
    },
    {
      path: 'listing/:id/facebook',
      name: 'Facebook',
      component: () => {
        const authStore = useAuthStore();
      
        if (authStore.user.current_shop?.shop_name == null) {
          return import('@/modules/traffic-stats/pages/Etsy.vue');
        }

        return import('@/modules/traffic-stats/pages/Facebook.vue');
      },
    },
    {
      path: 'listing/:id/:pathMatch(.*)*',
      name: 'Random-Source',
      component: () => {
        const authStore = useAuthStore();
      
        if (authStore.user.current_shop?.shop_name == null) {
          return import('@/modules/traffic-stats/pages/Etsy.vue');
        }

        return import('@/modules/traffic-stats/pages/Organic.vue');
      },
    },
    {
      path: 'listing/:id/badges',
      name: 'Badges-Listing',
      component: () => {
        const authStore = useAuthStore();
      
        if (authStore.user.current_shop?.shop_name == null) {
          return import('@/modules/traffic-stats/pages/Etsy.vue');
        }

        return import('@/modules/traffic-stats/pages/BadgesListings.vue');
      },
    },
  ],
};